/* eslint-disable max-classes-per-file */

export interface RequestHolidayInterface {}

export interface ResponseHolidayDataInterface {
  success: boolean;
  cache: boolean;
  data: DataInterface[];
}

export interface DataInterface {
  summary?: string;
  description?: string;
  date: DataTypeInterface;
}

export interface DataTypeInterface {
  start: DateStartInterface;
  end: DateEndInterface;
}

export interface DateStartInterface {
  original?: string;
  timestamp: number;
  UTC?: string;
}

export interface DateEndInterface {
  original?: string;
  timestamp: number;
  UTC?: string;
}

class DateStartClass {
  original: string;

  timestamp: number;

  UTC: string;

  constructor(res?: Partial<DateStartInterface>) {
    this.original = res?.original || "";
    this.timestamp = res?.timestamp ?? 0;
    this.UTC = res?.UTC || "";
  }
}

class DateEndClass {
  original: string;

  timestamp: number;

  UTC: string;

  constructor(res?: Partial<DateEndInterface>) {
    this.original = res?.original || "";
    this.timestamp = res?.timestamp ?? 0;
    this.UTC = res?.UTC || "";
  }
}

class DataTypeClass {
  start: DateStartInterface;

  end: DateEndInterface;

  constructor(res?: Partial<DataTypeInterface>) {
    this.start = new DateStartClass(res?.start);
    this.end = new DateEndClass(res?.end);
  }
}

class DataClass {
  summary: string;

  description: string;

  date: DataTypeInterface;

  constructor(res?: Partial<DataInterface>) {
    this.summary = res?.summary || "";
    this.description = res?.description || "";
    this.date = new DataTypeClass(res?.date);
  }
}

export class ResponseHolidayDataClass {
  success: boolean;

  cache: boolean;

  data: DataInterface[];

  constructor(res?: Partial<ResponseHolidayDataInterface>) {
    this.success = res?.success ?? false;
    this.cache = res?.cache ?? false;
    this.data = (res?.data || []).map((item) => new DataClass(item));
  }
}
